export default __webpack_public_path__ + "static/media/info_bonus.min.b367b007.png";